import React, { useState, useEffect, useRef } from "react";
import Tab1Image from "../img/envision/automotivemobility/tabthree/securemangmenttabthre.jpg";
import Tab2Image from "../img/envision/automotivemobility/tabthree/robustdisastortabthree.jpg";
import Tab3Image from "../img/envision/automotivemobility/tabthree/transformedapplicationss.jpg";
import Tab4Image from "../img/envision/automotivemobility/tabthree/cloudaduption.jpg";
import Tab5Image from "../img/envision/automotivemobility/tabthree/businessalledgilly.jpg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const Automotivethirdtab = () => {
    const [activeTab, setActiveTab] = useState("tab1");
    const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay
    const tabContainerRef = useRef(null);
    // const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    const handleKnowMoreSecondClick = () => {
        navigate("/documentautomotivapage#documentAutomotivaPageSEeconddata");
    };
    const [isHovered, setIsHovered] = useState(false);
    // const handleTabClick = (tabId) => {
    //     setActiveTab(tabId);
    // };
    // Autoplay effect to change tabs every 3 seconds (3000ms)
    // Autoplay effect to change tabs every 3 seconds (3000ms)
    useEffect(() => {
        let tabInterval;

        if (!isHovered && isAutoPlayActive) {
            tabInterval = setInterval(() => {
                setActiveTab((prevTab) => {
                    const nextTabNum = parseInt(prevTab.replace("tab", "")) % 5 + 1;
                    return `tab${nextTabNum}`;
                });
            }, 3000);
        }

        return () => clearInterval(tabInterval);
    }, [activeTab, isHovered, isAutoPlayActive]);


    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
    };

    useEffect(() => {
        if (tabContainerRef.current) {
            const container = tabContainerRef.current;
            const activeTabElement = document.getElementById(activeTab);

            if (activeTabElement) {
                // Get the position of the active tab within the container
                const activeTabOffsetTop = activeTabElement.offsetTop;

                // Smoothly scroll the container to that position
                container.scrollTo({
                    top: activeTabOffsetTop - container.offsetTop, // Adjust based on the container's offset
                    behavior: 'smooth', // Smooth scroll
                });
            }
        }
    }, [activeTab]);
    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            // display: "flex",
            width: "80%",
            margin: "50px auto",
        },
        tabNav: {
            // display: "flex",
            flexDirection: "column",
            borderRight: "1px solid #fff",
            height: "350px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
            direction: "rtl", // This makes the scrollbar appear on the left side
        },

        tabButton: {
            padding: "25px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            // display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            // marginLeft: "10px",
            height: '350px',
            overflowY: "auto",
            cursor: "pointer"
        },
        image: {
            width: "312px",
            height: "314px",
            borderRadius: "10px",
            marginRight: "20px",

        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
            fontSize: "15px",
            // marginTop:"900px"
            height:"785px",

        },
        icon: {
            marginRight: "10px",
            fontSize: "24px",
            color: "#009ca5",
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            // marginLeft: "150px"
        },
        knowMoreButtonHover: {
            backgroundColor: "#e68a00",
        },
    };

    return (
        <div style={{ marginTop: '100px' }}>
            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: "rgb(236 115 34)" }}> Next-Gen Mobility &  </span> EV Sector:
            </h1>
            <div style={styles.container} className="tabclass-container-data">


                <div
                    style={{
                        ...styles.tabNav,
                        overflowY: 'auto', // Allow scrolling within the container
                        scrollBehavior: 'smooth', // Enable smooth scrolling within the container
                    }}
                    ref={tabContainerRef}
                    className="tabdata"
                 >
                    {[
                        'SECURED & MODERN INFRASTRCUTURE',
                        'ROBUST DISASTER RECOVERY & BUSINESS CONTINUITY',
                        'TRANSFORMED APPLICATIONS E.g., ERP Transformation',
                        'CLOUD ADOPTION',
                        'BUSINESS ALIGNED IT & SECURITY',
                    ].map((tab, index) => {
                        const tabId = `tab${index + 1}`;
                        return (
                            <button
                                key={tabId}
                                id={tabId}
                                style={{
                                    ...styles.tabButton,
                                    ...(activeTab === tabId
                                        ? { ...styles.activeTabButton, backgroundColor: 'rgb(236 115 34)', color: '#fff' }
                                        : {}),
                                }}
                                onClick={() => handleTabClick(tabId)}
                                className="tab-button-width"
                                onMouseEnter={(e) => {
                                    if (activeTab !== tabId) {
                                        e.currentTarget.style.backgroundColor = '#000'; // Change background to black on hover
                                        e.currentTarget.style.color = '#fff'; // Change text to white on hover
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (activeTab !== tabId) {
                                        e.currentTarget.style.backgroundColor = '#f0f0f0'; // Revert background on mouse leave
                                        e.currentTarget.style.color = ''; // Revert text color on mouse leave
                                    }
                                }}
                            >
                                {tab}
                            </button>
                        );
                    })}
                </div>

                <div style={styles.card} className="card-data-vertica-tabs" onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    <img
                        src={{ tab1: Tab1Image, tab2: Tab2Image, tab3: Tab3Image, tab4: Tab4Image, tab5: Tab5Image, }[activeTab]}
                        alt="Healthcare"
                        style={styles.image}
                        className="tab-image-data"
                    />
                    <div style={styles.textContent}
                    //  className="auto-tab-text-second"  
                    

                    className={`autotabthree 
                        ${activeTab === "tab1" ? "tab1-largesam-screen-margin" : ""} 
                     ${activeTab === "tab2" ? "tab2-largesam-screen-margin" : ""} 
                    ${activeTab === "tab3" ? "tab3-largesam-screen-margin" : ""} 
                    ${activeTab === "tab4" ? "tab4-largesam-screen-margin" : ""} 
                    ${activeTab === "tab5" ? "tab5-largesam-screen-margin" : ""} 
                    
                        `
        
                      }
                    >
                        {(() => {
                            const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
                            const contentArray = [
                                [
                                    ["<strong>Problem</strong>  "],
                                    [" The Automotive, Rail, and Next-Gen Mobility sectors face increasing risks from:"],
                                    [" Cyber Threats to Connected Systems – IoT-enabled vehicles, smart rail networks, and EV charging stations are vulnerable to attacks."],
                                    ["Legacy IT & OT Systems – Aging rail control, automotive IT, and mobility platforms lack cybersecurity readiness."],
                                    ["	Digital Payment & MaaS Security – EV charging, toll collection, and automated ticketing require PCI DSS compliance."],
                                    ["	Supply Chain & Vendor Risks – Unsecured integrations in automotive manufacturing and rail networks expose systems to cyber threats."],
                                    ["<strong>How DREBCON Can Help</strong>"],
                                    [" End-to-End Cybersecurity – Zero Trust Security, threat intelligence, and AI-powered risk detection for smart mobility infrastructure. "],
                                    [" Compliance Assurance – Ensures ISO/SAE 21434, WP.29, ISO 62443, CERT-In, and PCI DSS compliance. "],
                                    [" Cloud & IoT Security – Protects V2X (Vehicle-to-Everything) communication, smart rail networks, and connected transport systems."],
                                    [" Smart Payment Security – Secures EV charging transactions, toll payments, and digital transit fare systems."],
                                    [" Resilient Manufacturing & Supply Chains – Cybersecure automotive and rail production ecosystems."],
                                    [" Infrastructure Modernization & Asset Management – AI-driven predictive maintenance and secure cloud analytics."],
                                    ["<strong>Result</strong>"],
                                    ["Cyber-Secure Mobility – Protection of smart rail, connected vehicles, and next-gen transit networks."],
                                    ["Regulatory Compliance – Meets global security mandates and reduces risk exposure."],
                                    ["Secure Digital Transactions – Ensures PCI DSS compliance for tolls, EV charging, and automated fare collection."],
                                    [" Optimized & Resilient Operations – AI-driven monitoring, predictive maintenance, and secure digital infrastructure."],

                                    [" DREBCON secures and modernizes transportation infrastructure, ensuring the future of mobility is safe, efficient, and resilient"],
                                ],
                                [
                                    ["<strong>Problem</strong>"],
                                     ["   The Automotive, Rail, and Mobility sectors face increasing risks from:"],
                                    ["	Cyber Threats & System Failures – Attacks on connected vehicles, smart  rail systems, and transportation IT networks can cause service disruptions."],
                                    ["	Regulatory & Compliance Mandates – Compliance with ISO/SAE 21434, ISO 62443, CERT-In, and CEA mandates requires disaster recovery (DR) and business continuity (BCP) plans."],
                                    ["Unreliable Legacy Systems – Aging SCADA, ERP, and OT infrastructure lacks real-time failover and resilience."],
                                    ["Supply Chain Disruptions – Vendor or third-party failures affect automotive production, railway operations, and mobility services."],
                                    ["	Inadequate Incident Response – Slow recovery increases financial and reputational losses."],
                                    
                                    ["<strong>How DREBCON Can Help</strong>"],
                                    [" Comprehensive DR & BCP Planning – Failover strategies and rapid recovery solutions for automotive, rail, and smart mobility infrastructure."],
                                    [" Cyber Resilience & Threat Mitigation – Zero Trust Security, AI-driven risk detection, and SCADA/ICS backup solutions. "],
                                    [" Regulatory Compliance – Ensures adherence to ISO 22301 (Business Continuity), ISO 27001, ISO 62443, and CERT-In requirements."],
                                    [" Cloud-Based Disaster Recovery & Failover – Geo-redundant backup and secure cloud failover for critical infrastructure."],
                                    [" AI-Driven Risk Prediction & Automated Response – Reduces downtime with real-time monitoring and automated incident response."],
                                    [" Secure Vendor & Supply Chain Management – Ensuring continuity and resilience across automotive and rail operations."],
                                    ["<strong>Result</strong>"],
                                    ["Minimal Downtime & Fast Recovery – Ensures seamless mobility operations during."],
                                    ["Regulatory Compliance & Resilience – Meets ISO 22301, ISO 27001."],
                                    ["Secure, Future-Ready Mobility – Cloud-enabled recovery and failover ensure transport continuity."],
                                    ["DREBCON safeguards Automotive, Rail, and Mobility sectors with resilient disaster recovery and business continuity solutions"],
                                ],
                                [
                                    ["<strong>Problem</strong>"],
                                    ["The Automotive, Rail, and Mobility sectors face major challenges due to outdated applications, including:</li></ul> "],
                                    ["	Legacy ERP & IT Systems – Older enterprise resource planning (ERP), SCADA, and mobility platforms lack real-time data integration and security."],
                                    ["	Operational Inefficiencies & Siloed Data – Disconnected systems slow decision-making, increase downtime, and impact supply chains."],
                                    ["Cybersecurity & Compliance Gaps – Legacy applications fail to meet ISO/SAE 21434, ISO 62443, CERT-In, and PCI DSS security requirements."],
                                    ["Limited AI & Cloud Integration – Traditional ERPs do not support cloud-based analytics, AI-driven insights, or IoT-enabled infrastructure. "],
                                    ["	High Costs & Limited Scalability – Maintaining outdated systems leads to rising operational costs and poor system performance."],
                                    ["<strong>How DREBCON Can Help</strong>"],
                                    [" ERP Modernization & Digital Transformation – Upgrading legacy ERP to cloud-based, AI-powered platforms for automotive and rail operations."],
                                    [" Secure SCADA & Asset Management Integration – Ensuring resilient and cybersecure automation systems."],
                                    [" AI & Cloud-Powered Analytics – Enabling predictive maintenance, fleet optimization, and smart infrastructure management."],
                                    [" Regulatory Compliance & Security Enhancement – Aligning with ISO 27001, ISO 62443, WP.29, and CERT-In cybersecurity frameworks."],
                                    [" Smart Payment & MaaS Platform Modernization – Enhancing toll systems, EV charging payments, and digital fare management."],
                                    [" End-to-End Supply Chain Digitalization – Connecting OEMs, suppliers, and transport networks with real-time data."],
                                    ["<strong>Result</strong>"],

                                    ["Optimized Costs & Efficiency – Reduced IT expenses, better asset utilization, and data-driven decision-making."],
                                    ["Seamless Connectivity Across Mobility Networks – Integrated applications ensure real-time transport and infrastructure coordination."],
                                    ["DREBCON accelerates ERP transformation, ensuring Automotive, Rail, and Mobility sectors stay secure, efficient, and future-ready."],

                                ],
                                [
                                    ["<strong>Problem</strong> "],
                                    ["The Automotive, Rail, and Mobility sectors face challenges in adopting cloud technology, including:"],
                                    ["	Legacy On-Premise Systems – Traditional ERP, SCADA, and asset management systems lack scalability, agility, and real-time data access."],
                                    ["	Cybersecurity & Compliance Risks – Cloud adoption must align with ISO/SAE 21434, ISO 27001, ISO 62443, WP.29, and CERT-In mandates."],
                                    ["	High Operational Costs & Inefficiencies – Maintaining on-premise infrastructure leads to high costs, slow performance, and limited innovation."],
                                    ["	Data Silos & Limited AI/IoT Integration – Legacy applications hinder AI-driven analytics, IoT-enabled infrastructure, and vehicle-to-everything (V2X) connectivity."],
                                    ["	Lack of Disaster Recovery & Redundancy – On-premise systems struggle with downtime, failover, and real-time disaster recovery solutions."],
                                    ["<strong>How DREBCON Can Help</strong>"],
                                    [" Cloud Strategy & Migration – Seamless transition from legacy systems to hybrid or multi-cloud environments for automotive, rail, and mobility operations."],
                                    [" Secure Cloud-Based SCADA & Asset Management – Ensuring cloud security for smart mobility, fleet management, and railway control systems."],
                                    [" AI & Data Analytics for Smart Mobility – Leveraging cloud-based AI/ML analytics for predictive maintenance, demand forecasting, and operational efficiency."],
                                    [" Regulatory Compliance & Cybersecurity – Ensuring ISO 27001, ISO 62443, CERT-In, and WP.29 compliance in cloud deployments."],
                                    [" Cloud Security & Zero Trust Frameworks – Implementing advanced encryption, identity management, and Zero Trust security models."],
                                    [" Disaster Recovery & High Availability – Cloud-based failover, geo-redundancy, and real-time recovery solutions for mobility infrastructure."],
                                    ["<strong>Result</strong>"],
                                    ["Scalable, Agile, and Cost-Effective IT Infrastructure – Optimized cloud resources, reduced IT expenses, and improved operational agility."],

                                    ["Enhanced Cybersecurity & Compliance – Secure cloud adoption aligned with global and national cybersecurity frameworks."],
                                    ["AI-Driven Insights & Real-Time Data Access – Cloud-powered analytics for better decision-making and mobility optimization."],
                                    ["Resilient, Future-Ready Infrastructure – Ensures high availability, faster disaster recovery, and seamless mobility operations."],
                                    ["DREBCON accelerates cloud adoption, ensuring the Automotive, Rail, and Mobility sectors stay secure, agile, and innovation-driven."],
                                ],
                                [
                                    ["<strong>Problem</strong>"],
                                    ["The Automotive, Rail, and Mobility sectors face challenges in aligning IT and security with business goals, including:"],
                                    ["Disjointed IT & Security Strategies – Lack of integration between business objectives, IT transformation, and cybersecurity frameworks."],
                                    ["Regulatory Compliance Gaps – Struggles in meeting ISO/SAE 21434, WP.29, ISO 62443, CERT-In, and PCI DSS mandates."],
                                    ["Limited AI & Cloud Integration – Traditional ERPs do not support cloud-based analytics, AI-driven insights, or IoT-enabled infrastructure. "],
                                    ["Cybersecurity & Compliance Gaps – Legacy applications fail to meet ISO/SAE 21434, ISO 62443, CERT-In, and PCI DSS security requirements."],
                                    ["	High IT & Security Costs – Overlapping security tools, redundant investments, and fragmented risk management increase expenses."],
                                    ["<strong>How DREBCON Can Help</strong>"],
                                    [" Strategic IT & Security Alignment – Integrating IT, cybersecurity, and risk management with business objectives."],
                                    [" Regulatory Compliance & Governance – Ensuring ISO 27001, ISO/SAE 21434, WP.29, ISO 62443, and CERT-In compliance."],
                                    [" Zero Trust Security & Threat Intelligence – Proactive cyber defense, AI-driven risk detection, and secure IT-OT integration."],
                                    [" IT Modernization & Digital Transformation – Cloud adoption, ERP transformation, and secured IoT/V2X implementations."],
                                    [" Smart Payment & MaaS Platform Modernization – Enhancing toll systems, EV charging payments, and digital fare management."],

                                    [" Cost-Optimized IT & Security Investments – Reducing inefficiencies while enhancing security resilience."],
                                    [" Business Continuity & Disaster Recovery – Ensuring IT-security integration for seamless mobility operations."],
                                    ["<strong>Result</strong>"],
                                    ["Stronger Cybersecurity & Compliance – Aligns IT and security with business objectives while meeting industry regulations."],

                                    ["Optimized Costs & Efficiency – Reduced IT expenses, better asset utilization, and data-driven decision-making."],
                                    ["Improved Operational Continuity & Risk Mitigation – Secure, agile IT that enables business growth and innovation."],
                                    ["DREBCON ensures IT & Security are fully aligned with business goals, making Automotive, Rail, and Mobility sectors secure, efficient, and future-proof."],
                                ],
                            ];

                            const selectedContent = contentArray[tabIndex] || [];

                            return selectedContent.map((listItems, listIndex) => (
                                <ul key={listIndex} >
                                    {listItems.map((point, itemIndex) => (
                                        <li key={itemIndex} style={{ marginBottom: "0" }} dangerouslySetInnerHTML={{ __html: point }} />
                                    ))}
                                </ul>
                            ));
                        })()}

                        <button
                            style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                            onClick={handleKnowMoreSecondClick}
                            className="know-more-btn"
                        >
                            Know More
                        </button>
                    </div>



                </div>
            </div>

            {/* Dot Navigation */}
            <div style={styles.dotNav}>
                {[...Array(5)].map((_, index) => {
                    const tab = `tab${index + 1}`;
                    return (
                        <div
                            key={tab}
                            style={{
                                ...styles.dot,
                                ...(activeTab === tab ? styles.activeDot : {}),
                            }}
                            onClick={() => handleTabClick(tab)}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default Automotivethirdtab;
